// categoriesApi.js
import { baseApi } from '../baseApi';

export const categoriesApi = baseApi.injectEndpoints({
  reducerPath: 'categoriesApi',
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: () => '/categories', // Endpoint for GET /api/categories
      providesTags: ['Categories'], // If you're using tags for cache invalidation
    }),
    // You can add more endpoints for categories here if needed
  }),
});

export const {
  useGetCategoriesQuery, // Export the auto-generated hook for the getCategories query
  // Add other exported hooks here as you create more endpoints
} = categoriesApi;
